<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container fluid>
            <v-form   ref="searchOrganizationForm" @submit="performOrganizationSearch" onSubmit="return false">
                <v-card flat>
                    <v-container fluid>
                        <v-layout>
                            <v-flex md3>
                                <v-text-field type="text"
                                              label="Filter By Name"
                                              v-model="filter.name"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-btn outlined color="success" @click="performOrganizationSearch()">
                            Search
                            <v-icon right dark>mdi-magnify-plus-outline</v-icon>
                        </v-btn>
                        <v-btn outlined color="warning" @click="resetFilter()">
                            Reset
                            <v-icon right dark>mdi-autorenew</v-icon>
                        </v-btn>
                        <v-btn outlined color="info" @click="addOrganization()" v-if="$permissionHolder.hasPermission('ORGANIZATION.CREATE')">
                            Create Organization
                            <v-icon right dark>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
            <v-data-table :headers="headers"
                          :items="organizations"
                          class="elevation-1"
                          :options.sync="pagination"
                          :loading="loading"
                          :server-items-length="totalRecords">
                <template v-slot:item.actions="{ item }">
                    <v-btn icon v-if="$permissionHolder.hasPermission('ORGANIZATION.UPDATE')" v-on:click="editOrganization(item.id)">
                        <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>

<script>
    import axios from 'axios/index';
    import api from '@/api';
    export default {
        name:'Organizations',
        watch: {
            pagination: {
                handler () {
                    this.performOrganizationSearch()
                },
                deep: true
            }
        },
        data() {
            return {
                headers : [
                    {text:'Name',value:'name'},
                    {text:'Actions',value:'actions'},
                ],
                loading:false,
                users : [],
                organizations: [],
                totalRecords : null,
                pagination: {
                   // itemsPerPage : 25,
                 //   page : 0
                },
                filter : {
                    name : null
                }
            };
        },
        methods: {
            addOrganization() {
                this.$router.push({name: 'CreateOrganization'});
            },
            performOrganizationSearch : function() {
                this.loading = true;
                const that = this;
                const sortDesc = !!this.pagination.sortDesc[0];
                const sortOrder = sortDesc ? 'DESC' : 'ASC';
                api.organization.search({
                    pageNumber: this.pagination.page - 1,
                    rowsPerPage: this.pagination.itemsPerPage,
                    sortBy: this.pagination.sortBy,
                    sortOrder: sortOrder,
                    name : this.filter.name
                }).then(function(data) {
                    that.organizations = data.list;
                    that.totalRecords = data.totalRecords;
                    that.loading = false;
                });
            },
            resetFilter: function () {
                this.filter = {};
                this.performOrganizationSearch();
            },
            editOrganization(id) {
                this.$router.push({'path':'/organization/'+id});
            }
        }
    }

</script>

<style>
    .v-form .container {
        padding:16px;
    }
</style>